import * as CONST from "../const/action.const";
import * as UTILS from "../helpers/utils";

const initialState = {
  permissions_list: [],
  new_permission: null,
  data_permission: null,
  data_role:null,
  roles_list: [],
  new_role: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.CREATE_PERMISSION_SUCCESS:
      return {
        ...state,
        new_permission: payload,
        permissions_list: state.permissions_list.concat(payload).reverse()
      };
    case CONST.CREATE_PERMISSION_FAILURE:
      return {
        ...state,
        new_permission: null,
      };
    case CONST.GET_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions_list: payload.reverse(),
      };
    case CONST.GET_ALL_PERMISSIONS_FAILURE:
      return {
        ...state,
        permissions_list: [],
      };
    case CONST.FIND_PERMISSION_SUCCESS:
      return {
        ...state,
        data_permission: payload,
      };
    case CONST.FIND_PERMISSION_FAILURE:
      return {
        ...state,
        data_permission: null,
      };
    case CONST.UPDATE_PERMISSION_SUCCESS:
      const index_permission = UTILS.findObjectFromArrayWithId(state.permissions_list, payload.id)
      const new_permissions_list = state.permissions_list.map((content, i) => (
        index_permission === i ? payload : content
      ))
      return {
        ...state,
        data_permission: payload,
        permissions_list: new_permissions_list
      };
    case CONST.UPDATE_PERMISSION_FAILURE:
      return {
        ...state,
        data_permission: null,
      };
    case CONST.DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        data_permission: payload,
      };
    case CONST.DELETE_PERMISSION_FAILURE:
      return {
        ...state,
        data_permission: null,
      };
    case CONST.CREATE_ROLE_SUCCESS:
      return {
        ...state,
        new_role: payload,
        roles_list: state.roles_list.concat(payload)
      };
    case CONST.CREATE_ROLE_FAILURE:
      return {
        ...state,
        new_role: null,
      };
    case CONST.GET_ALL_ROLES_SUCCESS:
      return {
        ...state,
        roles_list: payload.reverse(),
      };
    case CONST.GET_ALL_ROLES_FAILURE:
      return {
        ...state,
        roles_list: [],
      };
    case CONST.FIND_COURSE_SUCCESS:
      return {
        ...state,
        data_role: payload,
      };
    case CONST.FIND_ROLE_FAILURE:
      return {
        ...state,
        data_role: null,
      };
    case CONST.UPDATE_ROLE_SUCCESS:
      const index_role = UTILS.findObjectFromArrayWithId(state.roles_list, payload.id)
      const new_roles_list = state.roles_list.map((content, i) => (
        index_role === i ? payload : content
      ))
      return {
        ...state,
        data_role: payload,
        roles_list: new_roles_list
      };
    case CONST.UPDATE_ROLE_FAILURE:
      return {
        ...state,
        data_role: null,
      };
    case CONST.DELETE_ROLE_SUCCESS:
      return {
        ...state,
        data_role: payload,
      };
    case CONST.DELETE_ROLE_FAILURE:
      return {
        ...state,
        data_role: null,
      };
    case CONST.ADD_PERMISSION_TO_ROLE_SUCCESS:
      console.log("payload1111111111111",payload)
      // const get_role = state.roles_list.filter(role => role.name === payload.name)
      // // get_role.concat(payload.permissionIds)
      // console.log("get_role", get_role)
      
      var roles = [...state.roles_list];
      for (var i in roles) {
        roles[i] = { ...state.roles_list[i] };
        console.log("roles[i]",roles[i])
        if (roles[i].name === payload.role) {
          let cloneMe = [...roles[i].permissions]
          console.log("cloneMe1111111111",cloneMe)
          payload.permissions.forEach((permission, index1) => {
              cloneMe.push(permission)
          })
           console.log("cloneMe222222222222",cloneMe)
          roles[i].permissions = cloneMe
          console.log("roles[i]2",roles[i])
          console.log("rolesss", roles)
        }
      }
      return {
        ...state,
        roles_list: roles,
      };
    case CONST.ADD_PERMISSION_TO_ROLE_FAILURE:
      return {
        ...state,
        roles_list: [],
      };
    default:
      return state;
  }
}
